module.exports = __webpack_public_path__ + "effra.c2c17bded5ae58adfd15.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/effra.woff
// module id = 648
// module chunks = 2